import { Modal } from "components/Modal";
import { Formik } from "formik";
import validationSchema from "./AskAQuestion.schema";
import { useInitialState, useSubmitHandler } from "./AskAQuestion.hooks";
import AskAQuestionForm from "./AskAQuestion.component";
import config from "config";

interface IProps {
  isShowing: boolean;
  onHide: () => void;
}

export default function AskAQuestionModal({ isShowing, onHide }: IProps) {
  const initialState = useInitialState();
  const onSubmit = useSubmitHandler(onHide);

  return (
    <Modal
      isShowing={isShowing}
      onHide={onHide}
      customMaxWidth
      title={`Ask a ${config.PLATFORM_NAME} Expert`}
      closeLight
      classNames={{
        popup: "w-full max-w-[570px] rounded-lg  ",
        popupContainer: "overflow-y-hidden rounded-lg text-primary h-full",
        popupInner: "pl-6 pr-6 pt-2 pb-0 md:pb-2 overflow-y-auto ",
        modalHeader: "pl-6 mt-5 flex justify-between font-bold",
        borderLine: "hidden",
        closeButtonContainer: "mr-2",
      }}
    >
      <Formik
        enableReinitialize
        initialValues={initialState}
        validationSchema={validationSchema()}
        onSubmit={onSubmit}
      >
        {(props) => <AskAQuestionForm onHide={onHide} {...props} />}
      </Formik>
    </Modal>
  );
}
